/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRegionRequest
 */
export interface UpdateRegionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRegionRequest
     */
    carrierRegion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRegionRequest
     */
    mccMnc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRegionRequest
     */
    locale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRegionRequest
     */
    timezoneName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRegionRequest
     */
    carrierName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRegionRequest
     */
    timezoneLongName?: string | null;
}

/**
 * Check if a given object implements the UpdateRegionRequest interface.
 */
export function instanceOfUpdateRegionRequest(value: object): value is UpdateRegionRequest {
    return true;
}

export function UpdateRegionRequestFromJSON(json: any): UpdateRegionRequest {
    return UpdateRegionRequestFromJSONTyped(json, false);
}

export function UpdateRegionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRegionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'carrierRegion': json['carrier_region'] == null ? undefined : json['carrier_region'],
        'mccMnc': json['mcc_mnc'] == null ? undefined : json['mcc_mnc'],
        'locale': json['locale'] == null ? undefined : json['locale'],
        'timezoneName': json['timezone_name'] == null ? undefined : json['timezone_name'],
        'carrierName': json['carrier_name'] == null ? undefined : json['carrier_name'],
        'timezoneLongName': json['timezone_long_name'] == null ? undefined : json['timezone_long_name'],
    };
}

export function UpdateRegionRequestToJSON(json: any): UpdateRegionRequest {
    return UpdateRegionRequestToJSONTyped(json, false);
}

export function UpdateRegionRequestToJSONTyped(value?: UpdateRegionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carrier_region': value['carrierRegion'],
        'mcc_mnc': value['mccMnc'],
        'locale': value['locale'],
        'timezone_name': value['timezoneName'],
        'carrier_name': value['carrierName'],
        'timezone_long_name': value['timezoneLongName'],
    };
}

